import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.map.js";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
var camera,
  scene,
  renderer,
  controls,
  ob,
  fbx = 0,
  onProgress,
  attributeModels,
  manager,
  progressNums = [];
var tex, scale, PLight, Alight, hightlight, photonear, photofar, ambientcolor, pointColor, normalPath, parallelLight, normalMapStrength, onOtherProgress, envMap, group, raycaster, mousePointer;
var angleX = [];
var angleY = [];
var angleZ = [];
var axisX = [];
var anisY = [];
var anisZ = [];
var tex = [];
var model = [];
var modelName = [];
var mtl = [];
var index2 = [];
var index = [];
var mtlUrl = [];
var mtlName = [];
var normalPath = [];
var stageUrl = process.env.VUE_APP_IMG_URL;
var managerLoading, isPercentComplete;
var transTimeInterval;
export default {
  data() {
    return {
      detail: {},
      options: {
        source: '',
        width: 480,
        height: 327,
        frames: 34,
        framesX: 6,
        sense: -1
      },
      modelCenter: '',
      root: '',
      transY: '',
      //旋转的y值
      touchModelTime: '',
      //触发模型的时间
      sceneBox: '',
      oldCameraPosition: null,
      initLength: 0,
      preRatio: 1,
      isSide: false,
      transSpeed: 15,
      hasTrans: false
    };
  },
  methods: {
    showBigImg(item) {
      this.$parent.showBigImg = true;
      this.$parent.showBigImgIndex = index;
      this.$parent.bigImgUrl = item;
      this.$parent.handelShowBigImg();
    },
    // 3d数据解析
    get3dData(data) {
      document.getElementById("bar_" + this.detail.code).innerHTML = '';
      document.getElementById("loadbar_" + this.detail.code).style.display = 'block';
      document.getElementById("bar_" + this.detail.code).style.display = 'block';
      document.getElementById("bar_" + this.detail.code).style.width = '2%';
      let attribute3d = {
        highlight: this.getValInFormData(data, 'highLight'),
        zoomRatio: this.getValInFormData(data, 'zoom'),
        opacity: this.getValInFormData(data, 'transparency'),
        canvasColor: this.getValInFormData(data, 'color'),
        minDistance: this.getValInFormData(data, 'minDistance'),
        maxDistance: this.getValInFormData(data, 'maxDistance'),
        pointLight: this.getValInFormData(data, 'pointLight'),
        pointColor: this.getValInFormData(data, 'pointLightColor'),
        envLight: this.getValInFormData(data, 'environmentLight'),
        envColor: this.getValInFormData(data, 'environmentColor'),
        normalMapStrength: this.getValInFormData(data, 'normalMapStrength'),
        parallelLight: this.getValInFormData(data, 'parallelLight'),
        attributeModels: [],
        transSpeed: this.getValInFormData(data, 'transSpeed'),
        staticTime: this.getValInFormData(data, 'staticTime')
      };
      // 赋值旋转速率
      attribute3d.transSpeed ? this.transSpeed = this.transSpeed / parseFloat(attribute3d.transSpeed) : '';
      this.modelCenter = this.getValInFormData(data, 'modelCenter');
      this.detail.attribute3d = attribute3d;
      attributeModels = attribute3d.attributeModels;
      photonear = parseFloat(attribute3d.minDistance); //远相机
      photofar = parseFloat(attribute3d.maxDistance); //近相机
      scale = this.isMobile && this.$route.query.fid != 341648 && this.$route.query.code != '000042' ? parseFloat(attribute3d.zoomRatio) * 0.55 : parseFloat(attribute3d.zoomRatio); //缩放
      PLight = parseFloat(attribute3d.pointLight); //点光
      pointColor = attribute3d.pointColor; //点光颜色
      hightlight = parseFloat(attribute3d.highlight); //半球光颜色、在场景之上，光照颜色从天空光线颜色颜色渐变到地面光线颜色
      Alight = parseFloat(attribute3d.envLight); //环境光
      ambientcolor = attribute3d.envColor; //环境光颜色
      parallelLight = parseFloat(attribute3d.parallelLight); //平行光（太阳光）
      normalMapStrength = parseFloat(attribute3d.normalMapStrength); //法线贴图强度

      if (process.env.NODE_ENV == 'development') {
        data[25].groupValues.map((item, index) => {
          let itemData = {
            angleX: parseFloat(this.getValInFormData(data, 'angleX', '', index)),
            angleY: parseFloat(this.getValInFormData(data, 'angleY', '', index)),
            angleZ: parseFloat(this.getValInFormData(data, 'angleZ', '', index)),
            axisX: parseFloat(this.getValInFormData(data, 'axisX', '', index)),
            axisY: parseFloat(this.getValInFormData(data, 'axisY', '', index)),
            axisZ: parseFloat(this.getValInFormData(data, 'axisZ', '', index)),
            modelName: data[25].groupValues[index].values[0][0] ? data[25].groupValues[index].values[0][0].name : '',
            mtlName: data[23].groupValues[index].values[0][0] ? data[23].groupValues[index].values[0][0].name : '',
            mtlFile: data[23].groupValues[index].values[0][0] ? data[23].groupValues[index].values[0][0].name : '',
            modelPath: data[25].groupValues[index].values[0][0] ? stageUrl + data[25].groupValues[index].values[0][0].name : '',
            normalPath: data[26].groupValues[index].values[0][0] ? stageUrl + data[26].groupValues[index].values[0][0].name : '',
            chartlet: data[24].groupValues[index].values[0][0] ? stageUrl + data[24].groupValues[index].values[0][0].name : ''
          };
          attributeModels.push(itemData);
          if (attributeModels.length == data[25].groupValues.length) {
            this.$nextTick(() => {
              setTimeout(() => {
                this.init3d();
                this.animate();
              }, 1000);
            });
          }
        });
      } else {
        let t_url = {};
        data[25].groupValues.map((item, index) => {
          let t_name = [];
          let itemData = {
            angleX: parseFloat(this.getValInFormData(data, 'angleX', '', index)),
            angleY: parseFloat(this.getValInFormData(data, 'angleY', '', index)),
            angleZ: parseFloat(this.getValInFormData(data, 'angleZ', '', index)),
            axisX: parseFloat(this.getValInFormData(data, 'axisX', '', index)),
            axisY: parseFloat(this.getValInFormData(data, 'axisY', '', index)),
            axisZ: parseFloat(this.getValInFormData(data, 'axisZ', '', index)),
            modelName: data[25].groupValues[index].values[0][0] ? data[25].groupValues[index].values[0][0].name : '',
            mtlName: data[23].groupValues[index].values[0][0] ? data[23].groupValues[index].values[0][0].name : '',
            normalPath: data[26].groupValues[index].values[0][0] ? `https://museum.chaoxing.com/star3/origin/${data[26].groupValues[index].values[0][0].objectId}.${data[26].groupValues[index].values[0][0].suffix}` : ''
          };
          // mtl文件和obj文件
          let model1 = this.$api.getUrlByObjectId(data[23].groupValues[index].values[0][0] ? data[23].groupValues[index].values[0][0].objectId : '');
          let model2 = this.$api.getUrlByObjectId(data[25].groupValues[index].values[0][0] ? data[25].groupValues[index].values[0][0].objectId : '');
          // 贴图文件
          let ts = data[24].groupValues[index].values[0];
          // 法线贴图文件
          let ns = data[26].groupValues[index].values[0];
          let modelAll = [model1, model2];
          // 将图片数据统一为名称对应下载地址的格式，保存在localStorage
          ts.map(t => {
            let m = this.$api.getUrlByObjectId(t.objectId);
            modelAll.push(m);
            t_name.push(t.name);
            let t_name_str = t.name.toLocaleLowerCase();
            t_url[t_name_str] = `https://museum.chaoxing.com/star3/origin/${t.objectId}.${t.suffix}`;
          });
          ns.map(n => {
            let m = this.$api.getUrlByObjectId(n.objectId);
            modelAll.push(m);
            t_name.push(n.name);
            let t_name_str = n.name.toLocaleLowerCase();
            t_url[t_name_str] = `https://museum.chaoxing.com/star3/origin/${n.objectId}.${n.suffix}`;
          });
          itemData.chartlet = data[24].groupValues[index].values[0][0] ? `https://museum.chaoxing.com/star3/origin/${data[24].groupValues[index].values[0][0].objectId}.${data[24].groupValues[index].values[0][0].suffix}` : '';
          Promise.all(modelAll).then(res => {
            // mtl文件
            itemData.mtlFile = res[0].download || '';
            itemData.mtlFile = itemData.mtlFile.replace('http://d0.ananas.chaoxing.com/', 'https://museum.chaoxing.com/').replace('http://d0.cldisk.com/', 'https://museum.chaoxing.com/cldisk/');
            // 模型文件
            itemData.modelPath = res[1].download || '';
            itemData.modelPath = itemData.modelPath.replace('http://d0.ananas.chaoxing.com/', 'https://museum.chaoxing.com/').replace('http://d0.cldisk.com/', 'https://museum.chaoxing.com/cldisk/');
            // 贴图
            res.map((r, r_index) => {
              if (r_index > 1) {
                let t_name_str = t_name[r_index - 2].toLocaleLowerCase();
                console.log(t_name_str, 111);
                // t_url[t_name_str] = r.download.replace('http://d0.ananas.chaoxing.com/', 'https://museum.chaoxing.com/')
              }
            });
            if (t_name.length > 0) {
              window.localStorage.setItem("t_url", JSON.stringify(t_url));
            }
            console.log(itemData, 222);
            attributeModels.push(itemData);
            if (attributeModels.length == data[25].groupValues.length) {
              this.$nextTick(() => {
                setTimeout(() => {
                  this.init3d();
                  this.animate();
                }, 1000);
              });
            }
          });
        });
      }
    },
    // 按下事件
    onPointerDown(ev) {
      console.log(78567);
    },
    // 3d文物加载
    init3d() {
      attributeModels.map((a, i) => {
        angleX.push(a.angleX); //x轴
        angleY.push(a.angleY); //y轴
        angleZ.push(a.angleZ); //z轴
        axisX.push(a.axisX); //x轴
        anisY.push(a.axisY); //y轴
        anisZ.push(a.axisZ); //z轴
        model.push(a.modelPath); //文物路径
        modelName.push(a.modelName); //文物名称
        if (a.chartlet) {
          var new_c = a.chartlet.split('|');
          for (var c = 0; c < new_c.length; c++) {
            tex.push(new_c[c]);
          }
          //文物贴图
        }
        if (a.normalPath) {
          var new_n = a.normalPath.split('|');
          for (var c = 0; c < new_n.length; c++) {
            normalPath.push(new_n[c]);
          }
          //文物贴图
        }
        if (a.mtlFile) {
          mtl.push(a.mtlFile); //文物mtl
          index.push(mtl[i].lastIndexOf("\/"));
          var urlMtl = process.env.NODE_ENV == 'development' ? stageUrl : a.mtlFile.indexOf('cldisk') > -1 ? 'https://museum.chaoxing.com/cldisk/download/' : 'https://museum.chaoxing.com/download/';
          mtlUrl.push(urlMtl);
        }
        if (a.mtlName) {
          mtlName.push(a.mtlName);
        }
      });
      let that = this;
      scene = new THREE.Scene();
      if (that.$route.query.fid == 44578 && that.$route.query.code == '000030') {
        envMap = new THREE.CubeTextureLoader().setPath('https://museum.chaoxing.com/micro-frontend/content/test/').load(['111.jpg', '111.jpg', '111.jpg', '111.jpg', '111.jpg', '111.jpg']);
      }
      // let material = new THREE.MeshPhongMaterial();
      // material.envMap = scene.background;
      // let sphereGeometry = new THREE.SphereGeometry(20, 60, 60);
      // let sphere = new THREE.Mesh(sphereGeometry, material);
      // sphere.translateX(-95);
      // scene.add(sphere);
      camera = new THREE.PerspectiveCamera(35, window.innerWidth / window.innerHeight, photonear, photofar);
      camera.position.z = 250;
      // console.log(this.oldCameraPosition, 'oldCameraPosition')
      let detailCode = that.detailCode;
      scene.add(camera);
      group = new THREE.Object3D();
      scene.add(group);
      if (parallelLight) {
        let directionalLight = new THREE.DirectionalLight(0xffffff, parallelLight);
        // set(0,250,0) 这种情况是全覆盖的光，但是会有文物白底
        directionalLight.position.set(0, 250, 0);
        scene.add(directionalLight);
      }
      // 半球光，在场景之上从上到下的光
      var ambientLight = new THREE.AmbientLight(0xffffff, Alight);
      scene.add(ambientLight);
      var hemiLight = new THREE.HemisphereLight(0xffffff, 0xffffff, hightlight);
      hemiLight.position.set(0, 500, 0);
      scene.add(hemiLight);
      // 四个点光源
      var pointLight = new THREE.PointLight(0xffffff, PLight);
      pointLight.position.set(-300, 0, -100);
      scene.add(pointLight);
      var pointLight1 = new THREE.PointLight(0xffffff, PLight);
      pointLight1.position.set(100, 0, 300);
      scene.add(pointLight1);
      var pointLight2 = new THREE.PointLight(0xffffff, PLight);
      pointLight2.position.set(300, 0, -300);
      scene.add(pointLight2);
      var pointLight4 = new THREE.PointLight(0xffffff, PLight);
      pointLight4.position.set(0, -300, 0);
      scene.add(pointLight4);
      manager = new THREE.LoadingManager();
      var num = 0;
      var code = this.detail.code;

      // 创建射线实例
      raycaster = new THREE.Raycaster();
      mousePointer = new THREE.Vector2();
      this.root = document.querySelector("#containRelics");
      manager.onLoad = function () {
        console.log('onLoadManager');
        managerLoading = true;
        if (!isPercentComplete) return;
        // 所有资源都加载完成后执行事件
        document.getElementById('containRelics').style.visibility = 'visible';
        setTimeout(function () {
          document.getElementById("loadbar_" + code).style.display = 'none';
          document.getElementById("bar_" + code).style.display = 'none';
          that.modelTrans();
        }, 500);
      };
      //加载进度
      onProgress = function (xhr) {
        if (xhr.lengthComputable) {
          var percentComplete = xhr.loaded / xhr.total * 100;
          var percent = document.getElementById("bar_" + code);
          if (!percent) return;
          if (percentComplete == 100) {
            progressNums.push(100);
          }
          if (percentComplete > 80 && attributeModels.length != 1 && progressNums.length != attributeModels.length) {} else {
            var speed = Math.round(percentComplete, 2);
            percent.innerText = Math.round(percentComplete, 2) + '% 已经加载';
            document.getElementById("bar_" + code).style.width = speed == 0 ? 0 : speed - 1 + "%";
            document.getElementById("bar_" + code).innerHTML = speed == 0 ? 0 : speed - 1 + "%";
            if (document.getElementById('containRelics')) {
              document.getElementById('containRelics').style.visibility = 'hidden';
            }
            if (percentComplete == 100) {
              isPercentComplete = true;
              if (!managerLoading) return;
              document.getElementById('containRelics').style.visibility = 'visible';
              setTimeout(function () {
                document.getElementById("loadbar_" + code).style.display = 'none';
                document.getElementById("bar_" + code).style.display = 'none';
              }, 1500);
            }
          }
        }
      };
      // 多个模型进度条加载
      onOtherProgress = function (xhr) {
        var percentComplete = xhr.loaded / xhr.total * 100;
        if (percentComplete == 100) {
          progressNums.push(100);
        }
        if (progressNums.length == attributeModels.length && percentComplete > 80) {
          var percent = document.getElementById("bar_" + code);
          if (!percent) return;
          var speed = Math.round(percentComplete, 2);
          percent.innerText = Math.round(percentComplete, 2) + '% 已经加载';
          document.getElementById("bar_" + code).style.width = speed - 1 + "%";
          document.getElementById("bar_" + code).innerHTML = speed - 1 + "%";
          if (percentComplete == 100) {
            isPercentComplete = true;
            if (!managerLoading) return;
            document.getElementById('containRelics').style.visibility = 'visible';
            setTimeout(function () {
              document.getElementById("loadbar_" + code).style.display = 'none';
              document.getElementById("bar_" + code).style.display = 'none';
            }, 1500);
          }
        }
      };
      if (modelName[0].match('.obj') || modelName[0].match('.OBJ')) {
        if (mtlName[0] && mtlName[0].match('.mtl')) {
          that.loadNextMtl(0, detailCode);
        } else {
          that.loadNextObj(0, detailCode);
        }
      } else {
        fbx = 1;
        //可以在这里更换fbx试试其他效果
        loader.load(model[0], function (object) {
          object.position.set(0, 0, 0);
          object.scale.set(scale, scale, scale);
          ob = object;
          scene.add(object);
          object.children[0].geometry.center();
        });
      }
      renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true
      });
      renderer.setClearAlpha(0.0);
      renderer.setPixelRatio(window.devicePixelRatio);
      let h = document.documentElement.clientHeight;
      let w = document.documentElement.clientWidth;
      renderer.setSize(w, h);
      document.getElementById('containRelics').appendChild(renderer.domElement);
      // controls = new THREE.OrbitControls(camera, renderer.domElement);
      controls = new THREE.TrackballControls(camera, renderer.domElement);
      controls.minDistance = 200;
      controls.maxDistance = 2000;
      this.initLength = this.getPositionLength(camera.position);

      // const l2 = this.getPositionLength(camera.position);
      // this.preRatio = (this.initLength/l2).toFixed(1)
      // console.log(this.preRatio, '232')
      controls.addEventListener('change', () => {
        console.log('changeControls');
        const l = this.getPositionLength(camera.position);
        if (this.isSide) return;
        this.preRatio = (this.initLength / l).toFixed(1);
        // this.$refs.pageSidebar.setRatio((this.initLength/l).toFixed(1)*100);
        this.changeRatio((this.initLength / l).toFixed(1) * 50, false);
        if (transTimeInterval) return;
        clearInterval(transTimeInterval);
        transTimeInterval = '';
        this.touchModelTime = Date.parse(new Date());
      });

      // 绑定按下事件 检测是否和模型相交
      window.addEventListener('pointerdown', ev => {
        console.log('pointerdown');
        if (!this.hasTrans) return;
        // if (!that.transY) return
        // 归一化 -1~1之间  屏幕坐标到设备坐标
        mousePointer.x = ev.clientX / window.innerWidth * 2 - 1;
        mousePointer.y = -(ev.clientY / window.innerHeight) * 2 + 1;
        raycaster.setFromCamera(mousePointer, camera);
        // 计算物体和射线的焦点
        let intersects = raycaster.intersectObjects(scene.children, true);
        if (intersects.length) {
          //有触动模型，停止旋转
          console.log('clearInterval');
          clearInterval(transTimeInterval);
          transTimeInterval = '';
          // transTimeInterval = ''
          that.touchModelTime = Date.parse(new Date());
        }
      });
      var mousewheelevt = /Firefox/i.test(navigator.userAgent) ? "DOMMouseScroll" : "mousewheel";
    },
    // 文物自动旋转
    modelTrans() {
      // 自动旋转
      if (this.$route.query.fid != '210540' && this.$route.query.fid != '38655' && this.detail.autoTrans == '开启' && this.$route.query.fid != '200090') {
        this.hasTrans = true;
        let staticTime = this.detail.attribute3d.staticTime || 3;
        console.log(staticTime, 'staticTime');
        setTimeout(() => {
          transTimeInterval = setInterval(() => {
            let y = group.rotation.y - 0.01;
            this.transY = y;
            group.rotation.set(0, y, 0);
          }, this.transSpeed);
          setInterval(() => {
            this.userNoHandel();
          }, 1000);
        }, parseInt(staticTime * 1000)); //增加自动旋转之前的静止3s
      }
    },
    getPositionLength(position) {
      return Math.sqrt(Math.pow(position.x, 2) + Math.pow(position.y, 2) + Math.pow(position.z, 2));
    },
    deepClone(source) {
      if (!source || typeof source !== 'object') {
        return source;
        // throw new Error('error arguments', 'shallowClone');
      }
      var targetObj = source.constructor === Array ? [] : {};
      for (var keys in source) {
        if (source.hasOwnProperty(keys)) {
          if (source[keys] && typeof source[keys] === 'object') {
            targetObj[keys] = source[keys].constructor === Array ? [] : {};
            targetObj[keys] = this.deepClone(source[keys]);
          } else {
            targetObj[keys] = source[keys];
          }
        }
      }
      return targetObj;
    },
    // 用户是否没有操作
    userNoHandel(type) {
      let now = Date.parse(new Date());
      if (now - this.touchModelTime >= 5000) {
        if (transTimeInterval) return;
        this.changeRatio(50, true, 'reset');
        transTimeInterval = setInterval(() => {
          let y = this.transY - 0.01;
          this.transY = y;
          group.rotation.set(0, y, 0);
          // console.log('transTimeInterval')
        }, this.transSpeed);
      }
    },
    // 加载obj
    loadNextObj(i, detailCode) {
      let that = this;
      if (i > modelName.length - 1) return;
      var textureLoader = new THREE.TextureLoader(manager);
      var texture = textureLoader.load(tex[i]);
      texture.minFilter = THREE.NearestFilter;
      var textureNormal;
      if (normalPath.length && normalPath[i]) {
        var normalImg = normalPath[i];
        textureNormal = textureLoader.load(normalImg);
      }
      var loader = new THREE.OBJLoader(manager);
      // return
      loader.load(model[i], function (object) {
        object.traverse(function (child) {
          if (child instanceof THREE.Mesh) {
            child.material = new THREE.MeshPhongMaterial({
              map: texture,
              normalMap: textureNormal,
              normalScale: new THREE.Vector2(normalMapStrength, normalMapStrength),
              emissive: texture,
              shininess: 1000,
              needsUpdate: true
              // transparent: true,
              // depthWrite: false,
            });
            if (modelName[i].indexOf('_2') > -1 && that.$route.query.fid == 44578 && that.$route.query.code == '000030') {
              child.material.envMap = envMap;
            }
            if (that.$route.query.fid == 44578 && that.$route.query.code == '000014' && modelName[i].indexOf('_1') > -1) {
              child.material.depthWrite = false;
              child.material.transparent = true;
            }
          }
        });
        object.children[0].geometry.computeBoundingBox();
        if (that.modelCenter == '开启') {
          object.children[0].geometry.center();
        }
        object.scale.x = object.scale.y = object.scale.z = scale;
        object.rotation.set(Math.PI * Number(angleX[i] / 180), Math.PI * Number(angleY[i] / 180), Math.PI * Number(angleZ[i] / 180));
        object.position.set(axisX[i], anisY[i], anisZ[i]);
        object.name = detailCode;
        group.add(object);
        that.render();
      }, i == 0 ? onProgress : onOtherProgress);
      // 
      // scene.add(group);
      that.loadNextObj(i + 1, detailCode);
    },
    // 加载mtl
    loadNextMtl(i) {
      let that = this;
      if (i > modelName.length - 1) return;
      var loader = new THREE.TextureLoader(manager);
      loader.setCrossOrigin("Anonymous");
      var mtlLoader = new THREE.MTLLoader(manager);
      mtlLoader.setCrossOrigin("Anonymous");
      mtlLoader.setPath(mtlUrl[i]); // obj mtl文件的目录
      let mtlLoaderName = mtl[i].replace(mtlUrl[i], '');
      mtlLoader.load(mtlLoaderName, function (materials) {
        materials.preload();
        var objLoader = new THREE.OBJLoader();
        objLoader.setMaterials(materials);
        objLoader.load(model[i], function (object) {
          object.children[0].geometry.computeBoundingBox();
          if (that.modelCenter == '开启') {
            object.children[0].geometry.center();
          }
          object.scale.x = object.scale.y = object.scale.z = scale;
          object.rotation.set(Math.PI * Number(angleX[i] / 180), Math.PI * Number(angleY[i] / 180), Math.PI * Number(angleZ[i] / 180));
          object.position.set(axisX[i], anisY[i], anisZ[i]);
          group.add(object);
          that.render();
        }, i == 0 ? onProgress : onOtherProgress);
        // scene.add(group);
        that.loadNextMtl(i + 1);
      });
    },
    // 图片文物类型加载
    initImage() {
      this.$nextTick(() => {
        if (this.detail.images.length > 1) {
          new Swiper(this.$refs.swiperImg, {
            pagination: {
              el: '.swiper-pagination'
            },
            slidesPerView: 'auto',
            initialSlide: 0,
            centeredSlides: true,
            runCallbacksOnInit: false,
            touchMoveStopPropagation: true,
            slideToClickedSlide: true,
            observer: true,
            observeSlideChildren: true
            // autoplay: true,
          });
        }
        if (!this.isMobile) {
          $('.imagslist').smartZoom({
            containerClass: "zoomableContainer"
          });
        }
      });
    },
    // 360文物加载
    init360(data) {
      let images = data['panorama'].groupValues[0].values[0];
      images = images.map(item => {
        return process.env.NODE_ENV == 'development' ? stageUrl + '360/' + item.name : item.fileUrl ? item.fileUrl.replace('http:', 'https:') : '';
      });
      this.detail.images360 = images;
      this.options.source = images;
      this.$nextTick(() => {
        loadImage();
      });
    },
    // 获取音频
    getAudioPath(path, type) {
      this.$api.getUrlByObjectId(path).then(res => {
        let data = res.http.replace('https://s2.ananas.chaoxing.com/', 'https://museum.chaoxing.com/').replace('https://s1.ananas.chaoxing.com/', 'https://museum.chaoxing.com/');
        if (type == 'other') return this.detail.audioOther = data;
        !type ? this.detail.audio = data : this.detail.video = data;
      });
    },
    // getAudioPath(path, type) {
    //   this.detail.audio = 'https://museum-backend.chaoxing.com/api/file/front/' + path
    //   // this.$api.getUrlByObjectId(path).then((res) => {
    //   //   console.log(res)
    //   //   let data = res.http.replace('https://s2.ananas.chaoxing.com/', 'https://museum.chaoxing.com/').replace('https://s1.ananas.chaoxing.com/', 'https://museum.chaoxing.com/')
    //   //   !type ? this.detail.audio = data : this.detail.video = data
    //   //   this.$route.query.fid == 200090 && this.$route.query.code == '000045' ? this.detail.video = data : ''
    //   // })
    //   console.log(this.detail)
    // },
    getValInFormData(data, id, type, index) {
      index = index ? index : 0;
      if (!data[id] || !data[id].groupValues[index] || !data[id].groupValues[index].values[0].length) {
        return '';
      }
      let target;
      if (type && type == 'img') {
        if (!data[id].groupValues[index].values[0][0]) return '';
        target = process.env.NODE_ENV == 'development' ? stageUrl + data[id].groupValues[index].values[0][0].name : data[id].groupValues[index].values[0][0].fileUrl;
        target = target && process.env.NODE_ENV != 'development' ? target.replace('http:', 'https:') : target;
      } else {
        target = type ? data[id].groupValues[index].values[0][0][type] : data[id].groupValues[index].values[0][0].val;
      }
      return target;
    },
    // 还原
    changeRatio(data, update, type) {
      if (type) {
        controls.reset();
      }
      const scale_new = data / 100 * 2;
      const rate = this.preRatio / scale_new;
      this.controlNum = parseInt(data);
      // console.log(this.preRatio, 'preRatio', rate)
      if (!update) return;
      this.isSide = true;
      let that = this;
      // console.log(type, 11)
      camera.position.set(camera.position.x * rate, camera.position.y * rate, camera.position.z * rate);
      // camera.position.set(
      //   0,
      //   0,
      //   camera.position.z*scale,
      // )
      renderer.render(scene, camera);
      this.preRatio = scale_new;
      this.isSide = false;
    },
    animate() {
      requestAnimationFrame(this.animate);
      if (controls) {
        this.render();
        controls.update();
      } else {
        cancelAnimationFrame(this.animate);
      }
    },
    render() {
      renderer.render(scene, camera);
    },
    // 通过文物编号获取当前文件信息及文物信息
    getDetailByCode(hideOther, isAdd) {
      // 当前文物的信息
      let a = {
        filters: [[{
          alias: "autoId",
          compt: "editinput",
          express: "===",
          id: 28,
          range: null,
          val: this.detailCode
        }]],
        model: 0
      };
      let singleform = {
        deptId: this.$route.query.fid || '151066',
        formId: 112720,
        searchStr: encodeURI(JSON.stringify(a))
      };
      console.log(a, 'lsd');
      this.$api.singleadvanceSearch(singleform).then(res => {
        this.setData(res.dataList[0].formIdValueData, 'name', hideOther, isAdd);
      });
    },
    // 数据获取
    setData(data, type, hideOther, isAdd) {
      if (type == 'name') {
        //文物信息
        this.detail.name = this.getValInFormData(data, 'antiqueName');
        this.detail.img = this.getValInFormData(data, 'thumbPath', 'img');
        this.detail.description = this.getValInFormData(data, 'description');
        this.detail.audio = this.getValInFormData(data, 'audio', 'objectId');
        this.detail.audioOther = this.getValInFormData(data, 'audioOther', 'objectId');
        this.detail.columnName = this.getValInFormData(data, 33);
        this.detail.zhuanti = this.isMobile ? this.getValInFormData(data, 'mobileSpecial') : this.getValInFormData(data, 'special');
        hideOther ? this.list.push(this.detail) : '';
        if (this.detail.audio) {
          this.getAudioPath(this.detail.audio);
        }
        if (this.detail.audioOther) {
          this.getAudioPath(this.detail.audioOther, 'other');
        }
        if (this.detail.zhuanti) {
          this.$emit('hasZhuanti', this.detail.zhuanti);
        }
        return this.getFileData(isAdd);
      } else {
        //文件信息
        this.detail.type = this.getValInFormData(data, 'type');
        this.detail.code = this.detailCode;
        this.detail.isShow = this.getValInFormData(data, 'isShow');
        this.detail.autoTrans = this.getValInFormData(data, 'autoTrans') || '开启'; //是否自动旋转
        console.log(this.detail);
        this.getValInFormData(data, 'autoCode') ? this.detail.autoCode = this.getValInFormData(data, 'autoCode') : ''; //文件管理的自动编号，用来做访问量记录
        // 访问量

        let detail = JSON.parse(JSON.stringify(this.detail));
        if (type == 'addActiveItem') {
          this.$emit('setParent', 1, detail);
        }
        this.$emit('setParent', 2, detail);
        if (this.detail.type == '图片') {
          this.detail.images = data['image'].groupValues[0].values[0].map(img => {
            return process.env.NODE_ENV == 'development' ? stageUrl + img.name : img.fileUrl ? img.fileUrl.replace('http:', 'https:') : '';
          });
          this.$emit('setParent', 2, JSON.parse(JSON.stringify(this.detail)));
          this.$nextTick(() => {
            this.initImage();
          });
          return;
        }
        if (this.detail.type == '视频') {
          let objectId = this.getValInFormData(data, 'video', 'objectId');
          this.$nextTick(() => {
            this.getAudioPath(objectId, 'video');
          });
          return;
        }
        if (this.detail.type == '3D') {
          this.$nextTick(() => {
            this.get3dData(data);
          });
          return;
        }
        this.init360(data);
      }
    },
    // 通过展示文物编号获取当前文物的展示信息
    getFileData(isAdd) {
      //赣州查看是否没有展示文件
      let singleformFile = {
        deptId: this.$route.query.fid || '151066',
        formId: 113010
      };
      let index = this.$route.query.index ? parseInt(this.$route.query.index) : 0;
      let b = this.$route.query.autoCode ? {
        filters: [[{
          alias: "autoCode",
          compt: "editinput",
          express: "===",
          range: null,
          val: this.$route.query.autoCode
        }]],
        model: 0
      } : {
        filters: [[{
          alias: "autoId",
          compt: "editinput",
          express: "===",
          id: 28,
          range: null,
          val: this.detailCode
        }]],
        model: 0
      };
      this.$route.query.autoCode ? index = 0 : '';
      // if (this.$route.query.autoCode) {
      //   b.filters.push([{
      //     alias: "autoId",
      //     compt: "autonumber",
      //     express: "===",
      //     id: 68,
      //     range: null,
      //     val: this.$route.query.autoCode
      //   }])
      //   index = 0
      // }
      singleformFile.searchStr = encodeURI(JSON.stringify(b));
      this.$api.singleadvanceSearch(singleformFile).then(res => {
        if (!res.totalRow) {
          this.detail.hasNoFile = true;
          let detail = JSON.parse(JSON.stringify(this.detail));
          return this.$emit('setParent', 2, detail);
        }
        this.setData(res.dataList[index].formIdValueData, isAdd);
        this.setRecord();
      });
    },
    // 增加访问量
    setRecord(item) {
      if (!this.$route.query.autoCode && !this.detail.autoCode) return;
      let params = {
        formId: 571415,
        deptId: this.$route.query.fid || '151066'
      };
      let b = {
        filters: [[{
          alias: "autoCode",
          compt: "editinput",
          express: "===",
          range: null,
          val: this.$route.query.autoCode || this.detail.autoCode
        }]],
        model: 0
      };
      params.searchStr = encodeURI(JSON.stringify(b));
      // 获取访问量
      this.$api.singleadvanceSearch(params).then(res => {
        if (!res.dataList.length) return this.resetRecord(); //没有的时候新增一条数据
        let data = res.dataList[0].formIdValueData;
        let record = {
          chuanLiu: this.getValInFormData(data, 'chuanliu') || 0,
          pbl: this.getValInFormData(data, 'pbl') || 0,
          pc: this.getValInFormData(data, 'pc') || 0,
          yuDi: this.getValInFormData(data, 'yuDi') || 0,
          all: this.getValInFormData(data, 'all') || 0
        };
        // 访问量+1
        let putParams;
        putParams = [{
          "compt": "numberinput",
          "values": [{
            "val": record.chuanLiu
          }],
          "alias": 'chuanLiu'
        }, {
          "compt": "numberinput",
          "values": [{
            "val": record.yuDi
          }],
          "alias": 'yuDi'
        }, {
          "compt": "numberinput",
          "values": [{
            "val": record.pbl
          }],
          "alias": 'pbl'
        }, {
          "compt": "numberinput",
          "values": [{
            "val": parseInt(record.pc) + 1
          }],
          "alias": 'pc'
        }, {
          "compt": "numberinput",
          "values": [{
            "val": parseInt(record.all) + 1
          }],
          "alias": 'all'
        }];
        putParams = encodeURI(JSON.stringify(putParams));
        this.$api.editForm(this.$route.query.fid, res.dataList[0].id, putParams, res.dataList[0].formId).then(res => {});
      });
    },
    // 新增访问量数据
    resetRecord() {
      let putParams = [{
        "compt": "numberinput",
        "values": [{
          "val": 0
        }],
        "alias": 'chuanLiu'
      }, {
        "compt": "numberinput",
        "values": [{
          "val": 0
        }],
        "alias": 'yuDi'
      }, {
        "compt": "numberinput",
        "values": [{
          "val": 0
        }],
        "alias": 'pbl'
      }, {
        "compt": "numberinput",
        "values": [{
          "val": 1
        }],
        "alias": 'pc'
      }, {
        "compt": "numberinput",
        "values": [{
          "val": 1
        }],
        "alias": 'all'
      }, {
        "compt": "editinput",
        "values": [{
          "val": this.$route.query.autoCode || this.detail.autoCode
        }],
        "alias": 'autoCode'
      }, {
        "compt": "editinput",
        "values": [{
          "val": this.detail.name
        }],
        "alias": 'name'
      }, {
        "compt": "editinput",
        "values": [{
          "val": this.detail.type
        }],
        "alias": 'type'
      }];
      console.log(putParams);
      putParams = encodeURI(JSON.stringify(putParams));
      let formparams = {
        deptId: this.$route.query.fid,
        formId: 571415,
        uid: 170870413
      };
      this.$api.addFormdata(formparams, putParams).then(res => {});
    },
    slideFun(data) {
      document.getElementById('threesixty_images').innerHTML = '';
      this.detail.type = '';
      this.getDetailByCode();
    }
  },
  props: ['detailIn', 'showModels', 'isMobile', 'activeIndex', 'detailCode'],
  mounted() {
    if (this.$parent.detail.type == '360') {
      document.getElementById('threesixty_images').innerHTML = '';
      this.detail.type = '';
    }
    if (this.activeIndex == -1) return this.getDetailByCode(false, 'addActiveItem');
    this.getDetailByCode();
  },
  watch: {
    showModels: {
      handler(newVal, oldVal) {
        if (this.detail.type == '图片') {
          this.$nextTick(() => {
            this.initImage();
          });
        }
      },
      deep: true // 加这个属性，深度监听
    }
  }
};